import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/mable-logo.png'


const _hoisted_1 = { class: "flex-col align-items-center v-spacer-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Oops, Page Not Found", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "v-spacer" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://mabletherapy.com/" }, " click here "),
  /*#__PURE__*/_createTextVNode(" to go back to the Mable website ")
], -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}